import { render, staticRenderFns } from "./HomeConsumer.vue?vue&type=template&id=4b3eea53&scoped=true"
import script from "./HomeConsumer.vue?vue&type=script&lang=js"
export * from "./HomeConsumer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3eea53",
  null
  
)

export default component.exports